import { AioExternalSingleWithSource } from "contexts/hierarchy/interface";
import { IEditorV3, removeStylesFromEditorV3 } from "editor-v3";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Removes Optional and Notes styles from all singles.
 * Applies `removeStylesFromEditorV3` to each single's `newText`.
 * Suitable for both hierarchy and TLF singles since both use `AioExternalSingle<IEditorV3>`.
 *
 * @param singles - The collection of external singles containing EditorV3 content to sanitise
 * @returns A new array of singles with Optional/Notes styles removed
 */
export const removeStylesFromSingles = (
  singles: AioExternalSingleWithSource<IEditorV3>[],
): AioExternalSingleWithSource<IEditorV3>[] => {
  return singles.map((single) => ({
    ...single,
    newText: removeStylesFromEditorV3(single.newText, STYLES_TO_DELETE, STYLES_TO_CLEAN),
  }));
};
